export default [
  {
    id: `material`,
    title: `Описание`,
    content: {
      description: `
        <p>Мягкий флисовый плед, доступный в размере 130 х 170 см. Ткань флис - прочная, приятная на ощупь и не тяжелая. Под пледом будет приятно спать и комфортно на нём сидеть в парке. Запечатываются обе стороны пледа на ваш выбор. Закругленные углы, а края аккуратно обработаны оверлоком.</p>
      `
    }
  },
  {
    id: `printing`,
    title: `Способ печати`,
    content: {
      printingInfo: `
        <p>
          Способ печати - сублимация. Принт становится частью ткани и не чувствуется на ощупь. Картинка получается яркой и сочной. Изображение не стирается, не выцветает и не трескается.
        </p>
        <p>Можно стирать в машинке. Гладить, желательно, на изнанку.</p>
      `
    }
  },
  {
    id: `price`,
    title: `Цены`
  },
  {
    id: `delivery`,
    title: `Доставка и оплата`
  },
  {
    id: `reviews`,
    title: `Отзывы`
  }
];
